import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { Button, Dialog, 
    TextField,
 } from "@mui/material";
import { AppDispatch, RootState } from "../../../state/configureStore";
import { AddModal, Subheader } from "../../../components/molecules/AddModal";
import { AlertData, updateAlertEmail } from "../../../state/thunks/machineAlertsThunks";
import { resetSavingStatus } from "../../../state/reducers/slices/machineAlertSlice";

interface EditAlertEmailModalProps {
    alert: AlertData | null; 
    onClose: () => void; 
}

export const EditAlertEmailModal = ({alert, onClose}: EditAlertEmailModalProps) => {
  
const dispatch = useDispatch<AppDispatch>();
const {loading} = useSelector((state: RootState) => state.machineAlert)
const [newEmail, setNewEmail] = useState("");
const [emailError, setEmailError] = useState(false);

useEffect(() => {
    if (alert) {
         setNewEmail(alert.emailRecipient);
         setEmailError(false); 
    }
}, [alert]); 

const handleSave = () => {
    if(!newEmail.includes("@")){
        setEmailError(true); 
        return;
    }
    if (alert && newEmail) {
      dispatch(
        updateAlertEmail({ alert, newEmail }) 
      );
      onClose(); 
    }
  };

  const handleClose = () => {
  dispatch(resetSavingStatus()); // <--- Detta rensar "failed" i Redux
  onClose();
};

  return (
  <AddModal
        title={'Update Email Recipient'}
        saving={loading ? 'saving' : 'idle'}
        open={Boolean(alert)}
        savingFailedMessage={'Saving failed. Please check your inputs below and your internet connection and try again.'}
        closeModal={handleClose}
        onSave={handleSave}>
  
        <Subheader title={`Incident type: ${alert?.eventType || ''}`} />
        <TextField
          autoFocus
          margin="normal"
          id="email_input_field"
          label="Email Address"
          value={newEmail}
          type="email"
          fullWidth
          onChange={(event) => {
            setNewEmail(event.target.value)
        if(emailError){
            setEmailError(false)
        }
        }}
          error={emailError}
          helperText={emailError ? "Please enter a valid email." : null}
        />
      </AddModal>
  );
};
